/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNewOrder } from '@/context/NewOrderContext';
import { firestore } from '@/lib/firebase/firebase';
import { CircularProgress } from "__barrel_optimize__?names=CircularProgress!=!@mui/material";
import { doc, updateDoc } from 'firebase/firestore';
import React from 'react';
function InspectionType() {
    const { order, setOrder, products } = useNewOrder();
    const handleSelectType = (productId)=>{
        setOrder((prev)=>({
                ...prev,
                stripe_product: products.find((product)=>product.id === productId) || null
            }));
        if (order.id) {
            const docRef = doc(firestore, 'orders', order.id);
            updateDoc(docRef, {
                stripe_product: products.find((product)=>product.id === productId) || null
            });
        }
    };
    if (products.length === 0) {
        return /*#__PURE__*/ _jsx("div", {
            className: "h-[50vh] flex items-center justify-center",
            children: /*#__PURE__*/ _jsx(CircularProgress, {})
        });
    } else {
        return /*#__PURE__*/ _jsxs("div", {
            className: "mt-10",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx("span", {
                        className: "text-xl",
                        children: "Inspection Type:"
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "flex flex-wrap flex-row gap-5 mt-5",
                    children: products.map((product, index)=>{
                        var _order_stripe_product, _product_default_price;
                        return /*#__PURE__*/ _jsx("div", {
                            className: "w-full sm:w-[300px] rounded-xl p-4 border cursor-pointer ".concat(((_order_stripe_product = order.stripe_product) === null || _order_stripe_product === void 0 ? void 0 : _order_stripe_product.id) === product.id ? 'border-cyan bg-cyan/10' : 'hover:bg-neutral-100 border-neutral-300'),
                            onClick: ()=>handleSelectType(product.id),
                            children: /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "flex items-center justify-center mb-5",
                                        children: product.images.length > 0 ? /*#__PURE__*/ _jsx("img", {
                                            src: product.images[0],
                                            alt: product.name,
                                            className: "h-20 object-contain"
                                        }) : /*#__PURE__*/ _jsx("div", {
                                            className: "h-20 flex items-center justify-center bg-neutral-200 rounded",
                                            children: /*#__PURE__*/ _jsx("span", {
                                                className: "text-sm text-neutral-500",
                                                children: "No Image"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "text-center",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "font-semibold",
                                                children: product.name
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "text-sm text-neutral-500 my-3",
                                                children: product.description ? product.description : 'No description available'
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                children: ((_product_default_price = product.default_price) === null || _product_default_price === void 0 ? void 0 : _product_default_price.unit_amount) ? "$".concat((product.default_price.unit_amount / 100).toFixed(2)) : 'Price not available'
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, index);
                    })
                })
            ]
        });
    }
}
export default InspectionType;
